export var getNumber = function getNumber() {
  return new Date().getTime() + Math.random();
};
export var getString = function getString() {
  return new Date().getTime().toString().concat((Math.random() * Math.random()).toString(36));
};